module.exports = __webpack_public_path__ + "media/images/weather-icons/fill/openweather-weathercodes/02d-9a86613b2a5a0aebf924087c7d324c74.svg";